import { STATE_USED } from '../../../constants'

const usedBidCards = state => state.bidCards.filter(bidCard => bidCard.state === STATE_USED && !bidCard.isExpired)
const unusedBidCards = state => state.bidCards.filter(bidCard => bidCard.state !== STATE_USED && !bidCard.isExpired)

export default {
  bidCards: state => state.bidCards,
  expiredBidCards: state => state.bidCards.filter(bidCard => bidCard.isExpired),
  usedBidCards: state => usedBidCards(state),
  unusedBidCards: state => unusedBidCards(state)
}



// WEBPACK FOOTER //
// ./src/store/modules/bid-cards/getters.js